import { useQueryParams } from 'react-commons';
import { useEffect, useRef } from 'react';
import { useGlobalState } from '../../../state/persistence';
import { ReferenceLabelTypeEnum } from '../../../types';
const entryRoutes = [
  `${process.env.REACT_APP_ORDER_URL}/wohnen/haushalt-fw10`,
  `${process.env.REACT_APP_ORDER_URL}/gewerbe`,
  `${process.env.REACT_APP_ORDER_URL}`,
];

const useStateQueryParams = () => {
  const { dispatchAppStore, dispatchQuestion, appStore, question } = useGlobalState();
  const done = useRef(false);

  const {
    email = undefined,
    reference = undefined,
    firstname = undefined,
    lastname = undefined,
    gender = undefined,
    firstName = undefined,
    lastName = undefined,
    salutation = undefined,
    insurance = undefined,
    affiliateId = undefined,
    ref = undefined,
    referenceLabelType = ReferenceLabelTypeEnum.CONTRACT,
  } = useQueryParams<{
    email: string;
    reference: string;
    firstname: string;
    lastname: string;
    firstName: string;
    lastName: string;
    salutation: string;
    gender: string;
    insurance: string;
    affiliateId: string;
    ref: string;
    referenceLabelType: string;
  }>();

  useEffect(() => {
    if (!done.current && entryRoutes.includes(window.location.pathname.replace(/\/+$/, ''))) {
      if (question.reference !== reference) dispatchQuestion('reference', reference);
      if (appStore.partnerReference !== reference) dispatchAppStore('partnerReference', reference);
      if (question.legalInsurance !== insurance) dispatchQuestion('legalInsurance', insurance);
      if (appStore.email !== email) dispatchAppStore('email', email);
      if (firstName && appStore.firstName !== firstName) dispatchAppStore('firstName', firstName);
      if (lastName && appStore.lastName !== lastName) dispatchAppStore('lastName', lastName);
      if (salutation && appStore.salutation !== salutation) dispatchAppStore('salutation', salutation);
      if (firstname && appStore.firstName !== firstname) dispatchAppStore('firstName', firstname);
      if (lastname && appStore.lastName !== lastname) dispatchAppStore('lastName', lastname);
      if (gender && appStore.salutation !== gender) dispatchAppStore('salutation', gender);
      if (appStore.referenceLabelType !== referenceLabelType)
        dispatchAppStore('referenceLabelType', referenceLabelType);
      if (!ref && affiliateId && appStore.ref !== affiliateId) dispatchAppStore('ref', affiliateId);
      if (ref && ref !== appStore.ref) dispatchAppStore('ref', ref);
      if (!ref && !affiliateId && appStore.ref) dispatchAppStore('ref', undefined);

      done.current = true;
    }
  }, [
    email,
    reference,
    firstName,
    lastName,
    salutation,
    insurance,
    affiliateId,
    ref,
    referenceLabelType,
    dispatchAppStore,
    dispatchQuestion,
    appStore,
    question,
  ]);
};

export default useStateQueryParams;
